
import { TICK_MS } from "../sim/movement";

export const MAX_CATCH_UP_TICKS = 8;

export const MAX_IN_FLIGHT = 16;

export class InputClock {
  private nextAtMs: number;
  private periodMs: number;

  /** Frames handed out. Equal to inputs produced, so a useful denominator. */
  produced = 0;

  forfeited = 0;

  constructor(nowMs: number, periodMs: number = TICK_MS) {
    this.periodMs = periodMs;
    this.nextAtMs = nowMs + periodMs;
  }

  due(nowMs: number, periodMs: number = this.periodMs): number {
    if (periodMs > 0) this.periodMs = periodMs;

    let owed = 0;
    while (this.nextAtMs <= nowMs && owed < MAX_CATCH_UP_TICKS) {
      this.nextAtMs += this.periodMs;
      owed += 1;
    }

    if (this.nextAtMs <= nowMs) {
      // Past the cap. Count what is being thrown away -- it is the honest
      // measure of how badly this client is stalling -- and restart the deadline
      // from now, so the next wake-up is owed one frame rather than the whole
      // backlog all over again.
      this.forfeited += Math.floor((nowMs - this.nextAtMs) / this.periodMs) + 1;
      this.nextAtMs = nowMs + this.periodMs;
    }

    this.produced += owed;
    return owed;
  }

  /** Milliseconds until the next frame comes due, never negative. */
  delayMs(nowMs: number): number {
    return Math.max(0, this.nextAtMs - nowMs);
  }

  /** When the next frame comes due, on the caller's clock. Exposed for tests. */
  get nextDueAtMs(): number {
    return this.nextAtMs;
  }
}
